var React = require('react');

function Close (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"close-24px"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"Search---List---Desktop","transform":"translate(-1373.000000, -314.000000)"},React.createElement("g",{"id":"close-24px","transform":"translate(1368.000000, 309.000000)"},[React.createElement("polygon",{"id":"Path","points":"0 0 24 0 24 24 0 24","key":0}),React.createElement("polygon",{"id":"Path","fill":"#FF8300","points":"19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12","key":1})])))]);
}

Close.defaultProps = {"width":"14px","height":"14px","viewBox":"0 0 14 14","version":"1.1"};

module.exports = Close;

Close.default = Close;
